import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ToastService } from 'src/app/Shared/services/toast/toast.service';
import { IHorse } from 'src/app/app-modules/seller/seller-modules/auctions/_interfaces/horse.interface';
import { environment } from 'src/environments/environment';
import { DecimalPipe, CommonModule, DatePipe, NgClass } from '@angular/common';
import { differenceInSeconds } from 'date-fns';
import { TimerComponent } from 'src/app/Shared/components/timer/timer.component';
import { CustomCurrencyPipe } from 'src/app/Shared/_pipes/currency-pipe/custom-currency-pipe.pipe';
import { Router, RouterLink } from '@angular/router';
import { isWinner, isSold, isUnSold } from 'src/app/_utlis/status-helper';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { AuctionItemStatusComponent } from '../auction-item-status/auction-item-status.component';
import { BidNowButtonComponent } from '../bid-now-button/bid-now-button.component';
import { MakeOfferBtnComponent } from '../make-offer-btn/make-offer-btn.component';
import { RequestToBidButtonComponent } from '../request-to-bid-button/request-to-bid-button.component';
import { PusherService } from 'src/app/Shared/services/pusher/pusher.service';
import * as Events from 'src/app/_contstants/pusher-contstants';
import { PusherSubscriptionService } from '../../services/pusher-subscription/pusher-subscription.service';
import {
  debounceTime,
  distinctUntilChanged,
  Subject,
  Subscription,
} from 'rxjs';
import { TermsAndConditionsAcceptanceService } from '../../services/terms-and-conditions-acceptance.service';
import { changeAuctionItemStatus } from 'src/app/_utlis/auctions-helpers';
import { NotificationWindowService } from 'src/app/Shared/_services/notification/notification.service';
import { TranslationsConvertKeyPipe } from 'src/app/Shared/_pipes/translations-convert-key.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { LocaleService } from 'src/app/Shared/services/locale/locale.service';
import { LocalizedNamePipe } from 'src/app/Shared/pipes/localized-name.pipe';
import { HorseNamePipe } from 'src/app/Shared/_pipes/horse-name.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalDateTimePipe } from 'src/app/Shared/_pipes/local-date-time';
import { HorseStatusDisplayService } from 'src/app/app-modules/buyer/buyer-shared/services/horse-status-display.service';
@Component({
    selector: 'app-auction-item-card',
        standalone: true,
templateUrl: './auction-item-card-new.component.html',
    styleUrls: ['./auction-item-card.component.scss'],
    imports: [
    TimerComponent,
    CommonModule,
    MatIcon,
    MatIconModule,
    RequestToBidButtonComponent,
    BidNowButtonComponent,
    NgClass,
    MakeOfferBtnComponent,
    CustomCurrencyPipe,
    MatTooltipModule,
    TranslatePipe,
    LocalizedNamePipe,
    LocalDateTimePipe,
    HorseNamePipe
],
    providers: [CustomCurrencyPipe, TranslationsConvertKeyPipe]
})
export class AuctionItemCardComponent {
  @Input() data: any;
  @Output() onViewDetails: EventEmitter<any> = new EventEmitter<any>();
  @Input() isLoading!: boolean;
  @Input() auctionType!: string;
  @Input() loggedIn!: boolean;
  @Input() showFavoriteButton: boolean = true;
  @Output() onHandleActions: EventEmitter<any> = new EventEmitter<any>();
  @Output() timeEnded: EventEmitter<any> = new EventEmitter<any>();
  @Input() locale: any;
  @Input() auctionSettings: any;
  @Input() aucType: any;
  @Input() userId: any;
  @Input() gradualEnding: any;
  @Input() dir!: any;
  @Input() auction!: any;
  @Input() horseOffers!: any;
  @Input() showType: boolean = false;
  @Input() showViews: boolean = false;
  @Input() showPedigree: boolean = false;
  @Input() showHip: boolean = false;
  @Input() showSeller: boolean = false;
  @Input() showAuctionName: boolean = false;
  @Input() isFromCatalogue: boolean = false;
  @Input() isUpcomingTimer: boolean = false;
  @Output() loadData: EventEmitter<any> = new EventEmitter<any>();
  @Output() favoriteClicked = new EventEmitter<any>();
  termsSub!: Subscription;
  private auctionItemUpdateSubject = new Subject<any>();
  private pusherSubscriptions: any[] = [];
  private subscriptions: Subscription[] = [];
  private isSubscribed = false;
  isDev: boolean = environment.isDev;

  constructor(
    private router: Router,
    private pusherService: PusherService,
    private pusherSubscriptionService: PusherSubscriptionService,
    private termsAcceptance: TermsAndConditionsAcceptanceService,
    private cdr: ChangeDetectorRef,
    private notification: NotificationWindowService,
    public localeService: LocaleService,
    private statusService: HorseStatusDisplayService
  ) {}
  isWithdrawHorse: boolean = true;
  ngOnInit(): void {
    if (this.userId && !this.isFromCatalogue) {
      this.subscribeToBuyerApplicationsChannels();
      this.subscribeToPrivateTermsAndConditionsUpdated();
      this.auctionItemUpdateDebouncing();
      this.subscribeToAuctionItemUpdated();
      this.subscribeToOfferUpdatesChannel();
    } else if (!this.userId && !this.isFromCatalogue) {
      this.unSubscribeToPrivateUserChannel();
    }
  }
  viewDetails(item: any) {
    this.onViewDetails.emit(item);
  }

  handleTimeEnded(item: any) {
    if (item.id === this.data?.id) {
      this.timeEnded.emit(item);
    }
  }
  get isRnaStatus(): boolean {
    // Check new status field (from backend) - rna_status is legacy
    return this.data?.status === 'rna';
  }

  get isWinnerStatus(): boolean {
    return this.data?.status === 'winner';
  }

  get isSoldStatus(): boolean {
    return this.data?.status === 'sold';
  }

  get isUnSoldStatus(): boolean {
    return this.data?.status === 'not_sold';
  }

  get isPSStatus(): boolean {
    return this.data?.status === 'ps';
  }

  get isNoStatusStatus(): boolean {
    return this.data?.status === 'no_status';
  }

  get showSoldFromOfferFallback(): boolean {
    return (
      !this.hasExplicitStatus &&
      !!this.horseOffers?.make_an_offer?.item_has_accepted_offer
    );
  }

  /**
   * Check if the horse has individually closed (has a status)
   * This is true when the horse's extended_end_date has passed and processing completed
   */
  get isHorseClosed(): boolean {
    return !!this.data?.status;
  }

  get hasExplicitStatus(): boolean {
    return this.data?.status !== null && this.data?.status !== undefined;
  }

  get isLegacyUnSoldFlag(): boolean {
    return !this.hasExplicitStatus && this.data?.unsold_flag_at != null;
  }

  get hasDisplayPrice(): boolean {
    return !!this.statusService.getDisplayPrice(this.data ?? {});
  }

  get shouldHideRnaZeroBidDisplayPrice(): boolean {
    return (
      this.isRnaStatus &&
      (this.data?.bids_count ?? null) === 0 &&
      this.displayPriceAmount === 0
    );
  }

  get shouldShowDisplayPrice(): boolean {
    return (
      this.hasDisplayPrice &&
      !this.shouldHideRnaZeroBidDisplayPrice &&
      (this.auctionType == 'previous' || this.isHorseClosed)
    );
  }

  get displayPriceLabelKey(): string | null {
    return this.statusService.getPriceLabel(this.data ?? {});
  }

  get displayPriceLabelAttr(): string | null {
    return this.displayPriceLabelKey
      ? this.displayPriceLabelKey.replace(/\./g, '_')
      : null;
  }

  get displayPriceAmount(): number | null {
    return this.statusService.getPriceAmount(this.data ?? {});
  }

  get displayPriceCurrency(): string | null {
    return (
      this.statusService.getCurrency(this.data ?? {}) ||
      this.auction?.currency?.currency_code ||
      null
    );
  }

  // Buyer status getters
  get isBlocked(): boolean {
    return this.auction?.buyer_status?.is_blocked === true;
  }

  get isSuspended(): boolean {
    return this.auction?.buyer_status?.is_suspended === true;
  }

  get isBlockedOrSuspended(): boolean {
    return this.isBlocked || this.isSuspended;
  }

  get sellerEmail(): string {
    return this.auction?.seller_email || this.auction?.seller?.user?.email || '';
  }
  get canViewButtonFullWidth(): boolean {
    return (
      this.auctionSettings.request_to_join_status === false ||
      (!this.data?.can_bid &&
        this.loggedIn &&
        this.auctionSettings.auction_buyer_last_record !== null &&
        this.auctionType !== 'previous' &&
        this.auctionType !== 'upcoming') ||
      (this.auctionType === 'previous' &&
        !this.isWinnerStatus &&
        !this.isRnaStatus &&
        !this.isSoldStatus &&
        !this.isUnSoldStatus)
    );
  }

  get canViewButtonHalfWidth(): boolean {
    return (
      this.auctionType === 'active' &&
      (this.isWinnerStatus ||
        this.isRnaStatus ||
        this.isSoldStatus ||
        this.isUnSoldStatus)
    );
  }

  get showRequestToBidButton(): boolean {
    return (
      (!this.loggedIn ||
        this.auctionSettings.auction_buyer_last_record ||
        (this.auctionSettings.auction_buyer_last_record === null &&
          !this.auctionSettings.request_to_join_status &&
          !this.auctionSettings.invited_buyer &&
          !this.auctionSettings.accepted_invited_buyer)) &&
      this.auctionType !== 'previous' &&
      !this.isRnaStatus &&
      !this.isWinnerStatus &&
      !this.isSoldStatus
    );
  }
  onFavoriteClick(e: any) {
    e.stopPropagation();
    this.favoriteClicked.emit(this.data);
  }
  gotToSellerPage(e: any, id: any) {
    e.stopPropagation();
    this.router.navigate(['/buyer/sellers/seller-details', id]);
  }
  handleActions($event: PointerEvent, action: string, rowId: number) {
    $event.stopPropagation(); // Stop event propagation here
    this.onHandleActions.emit({
      detail: {
        propagation: false,
        action,
        id: rowId,
      },
    });
  }
  goToBidPage(e: any, item: any) {
    this.router.navigate([
      '/buyer/auctions',
      item.auctionSlug,
      'horse',
      item?.slug,
    ]);
  }
  handleLoadData() {
    this.loadData.emit();
  }
  subscribeToAcceptedTerms() {
    this.termsSub = this.termsAcceptance.buyerAccepted$.subscribe((value) => {
      if (value?.isAccepted === 'accepted') {
        this.auction = {
          ...this.auction,
          buyer_accepted_seller_terms: value?.isAccepted,
        };
        this.cdr.detectChanges();
      }
    });
  }
  ngAfterViewInit() {
    this.subscribeToAcceptedTerms();
  }
  ////////////////////////////////////////////////////////////////////
  buyerApplicationsEvents: any[] = [
    {
      events: [
        {
          eventName: Events.BUYER_APP_ACCEPTED,
          showNot: true,
          pushTitle: 'Status Update',
          accepted: true,
        },

        {
          eventName: Events.BUYER_APP_REJECTED,
          showNot: true,
          pushTitle: 'Status Update',
          accepted: false,
        },
      ],
    },
  ];
  subscribeToBuyerApplicationsChannels() {
    this.buyerApplicationsEvents.forEach((channelConfig) => {
      channelConfig.events.forEach(
        (event: {
          eventName: string;
          showNot: boolean;
          pushTitle: string;
          accepted: boolean;
        }) => {
          this.pusherService.subscribeToPrivateChannel(
            'private-user.{user_id}', // Template channel name
            event.eventName,
            event.showNot,
            event.pushTitle,
            (data: {
              auction_ids: any;
              buyer_user_id: number;
              seller_id: number;
            }) => {
              if (data?.auction_ids) {
                if (data?.auction_ids.includes(this.data?.auction?.id)) {
                  this.auctionSettings = changeAuctionItemStatus(
                    event.accepted,
                    this.auctionSettings
                  );
                  if (event.accepted) {
                    this.handleLoadData();
                  }
                }
              }
            }
          );
        }
      );
    });
  }
  auctionItemUpdateDebouncing() {
    this.auctionItemUpdateSubject
      .pipe(
        debounceTime(300), // Wait 300ms after the last emission
        distinctUntilChanged((prev, curr) => {
          // Create a comparison key that ignores timestamp differences
          const prevKey = `${prev.auction_item_id}-${
            prev.auction_id
          }-${JSON.stringify(prev.bids)}-${JSON.stringify(prev.status)}`;
          const currKey = `${curr.auction_item_id}-${
            curr.auction_id
          }-${JSON.stringify(curr.bids)}-${JSON.stringify(curr.status)}`;

          const isDuplicate = prevKey === currKey;
          // if (isDuplicate) {
          //   console.log('Duplicate event filtered out by distinctUntilChanged');
          // }
          return isDuplicate;
        })
      )
      .subscribe((data) => {
        this.handleAuctionUpdate(data);
      });
  }
  pendingUpdates: any;
  subscribeToAuctionItemUpdated() {
    if (this.isSubscribed) {
      return;
    }

    const subscription = this.pusherSubscriptionService
      .getAuctionItemUpdates$()
      .subscribe((data) => {
        if (data.auction_item_id !== this.data?.id) {
          return; // Ignore events for other auction items
        }
        // Push to subject instead of handling directly
        this.auctionItemUpdateSubject.next(data);
      });

    // Store subscription for cleanup
    this.subscriptions.push(subscription);
    this.isSubscribed = true;
  }
  subscribeToPrivateTermsAndConditionsUpdated() {
    this.pusherSubscriptionService.subscribeToPrivateTermsAndConditionsUpdated(
      (data: any) => {
        if (data?.affected_auctions?.includes(this.data?.auction?.id)) {
          this.auction.seller_terms = data?.terms_and_conditions;
          this.auction.buyer_accepted_seller_terms = 'not accepted';
        }
      }
    );
  }
  subscribeToOfferUpdatesChannel() {
    this.pusherService.subscribeToPrivateChannel(
      'private-user.{user_id}',
      'item_offer.updated',
      true,
      'Offer Updated',
      (data: any) => {
        if (this.data?.id == data.auction_item_id) {
          this.handleLoadData();
        }
      }
    );
  }

  handleAuctionUpdate(data: any) {
    if (data?.auction_id == this.data?.auction?.id) {
      const item = this.data?.id == data?.auction_item_id ? this.data : null;

      if (item) {
        this.handleLoadData();

        this.notification.showNotification('Auctions Update', {
          body: ``,
          icon: 'assets/images/x-logo.png',
        });
      }
    }
  }
  private unsubscribeAllPusherEvents() {
    this.pusherSubscriptions.forEach((subscription) => {
      if (subscription && typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    });
    this.pusherSubscriptions = [];
    this.isSubscribed = false;
  }
  unSubscribeToPrivateUserChannel() {
    this.pusherService.unsubscribeFromPrivateChannel();
  }
  unSubscribeToPublicUserChannel() {
    this.pusherService.unsubscribeFromPublicChannel();
  }
  ngOnDestroy(): void {
    // Clean up RxJS subscriptions
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];

    if (this.termsSub && !this.isFromCatalogue) {
      this.termsSub.unsubscribe();
    }
    if (this.userId && !this.isFromCatalogue) {
      this.unSubscribeToPrivateUserChannel();
    }
    if (!this.isFromCatalogue) {
      this.unSubscribeToPublicUserChannel();
      this.auctionItemUpdateSubject.complete();
      this.unsubscribeAllPusherEvents();
    }
  }
}
